export default "__VITE_ASSET__4c923262__"